<script >

import bem from '@/utils/bem';
import TiptapEditor from '@/components/ux/bundleEditor/Tiptap-editor.vue';
import UploadFiles from '@/components/ux/upload/Upload-files.vue';
import createUploadFile from '@/utils/createUploadFile';

const b = bem('hint-help-center-modal');

export default {
  components: { UploadFiles, TiptapEditor },
  data() {
    return {
      activeKey: 'mainData',
      isNew: true,
      title: '',
      titleMobile: '',
      description: '',
      descriptionMobile: '',
      category: null,
      fileList: [],
    };
  },
  props: {
    hint: {
      type: Object,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    onSubmit: {
      type: Function,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    withoutCategory: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    hideModal() {
      this.$emit('update:show', false);
      this.$emit('update:hint', null);
      this.isNew = true;
      this.fileList = [];
      this.description = '';
      this.descriptionMobile = '';
      this.title = '';
      this.titleMobile = '';
      this.category = null;
    },
    addVideo({ linkVideo }) {
      if (linkVideo) {
        const newVideo = {
          image: linkVideo,
          isAutoPlay: false,
        };
        this.fileList = [...this.fileList, newVideo];
        this.$formkit.reset('videoForm');
      }
    },
    async onSave() {
      let imagesData = [];
      if (this.fileList.length) {
        try {
          imagesData = await Promise.all(this.fileList
            .map((item) => {
              const { url, file } = item;
              if (file) {
                return createUploadFile(url, 'wizard-badges');
              }
              return item;
            }, []));
        } catch (err) {
          imagesData = this.hint?.images || [];
        }
      }
      const uploadedImages = imagesData.map(
        (item) => {
          const { url, image } = item;
          if (url || image) {
            return { image: url || image, isAutoPlay: false };
          }
          const { data: { data: { url: newUrl } } } = item;
          return { image: newUrl, isAutoPlay: false };
        },
      );
      const categoryId = this.category?.value?.categoryId || null;
      this.onSubmit({
        ...(this.isNew ? {} : { id: this.hint.id }),
        images: uploadedImages,
        title: this.title,
        titleMobile: this.titleMobile,
        description: this.description,
        descriptionMobile: this.descriptionMobile,
        ...(this.withoutCategory ? {} : { categoryId }),
      });
      this.hideModal();
    },
    handleChangeCategory(_, option) {
      this.category = option;
    },
  },
  watch: {
    fileList() {
      this.linkVideo = '';
    },
    hint: {
      handler(newValue) {
        this.isNew = !newValue?.id;
        this.fileList = newValue?.images || [];
        this.description = newValue?.description || '';
        this.descriptionMobile = newValue?.descriptionMobile || '';
        this.title = newValue?.title || '';
        this.titleMobile = newValue?.titleMobile || '';
        const category = this.categories
          .find(({ categoryId }) => categoryId === newValue?.categoryId);
        this.category = category ? { label: category.title, value: category } : null;
      },
      deep: true,
    },
  },
};
</script>

<template>
  <a-modal
    :open="show"
    :footer="null"
    @cancel="hideModal"
    width="fit-content"
  >
    <div :class="b('')">
      <h1 :class="b('title')">{{ isNew ? 'Create new' : 'Edit' }} hint help center</h1>
      <a-tabs
        v-model:activeKey="activeKey"
        type="card"
      >
        <a-tab-pane
          key="mainData"
          tab="Main data"
        >
          <div :class="b('content-wrapper')">
            <div :class="b('uploader')">
              <upload-files
                :is-multiple="true"
                :files="fileList"
                :on-change="(value) => {
                  this.fileList = value;
                }"
              />
              <FormKit
                type="form"
                id="videoForm"
                submit-label="Add video"
                @submit="addVideo"
                :form-class="b('video-form')"
              >
                <FormKit
                  type="text"
                  name="linkVideo"
                  label="Add link frame video"
                  placeholder="Enter link"
                />
              </FormKit>
            </div>
            <div :class="b('input-wrapper')">
              <span :class="b('input-title')">Name hint</span>
              <a-input
                :class="b('input')"
                type="text"
                placeholder="Enter name hint"
                v-model:value="title"
              />
            </div>
            <div :class="b('input-wrapper')">
              <span :class="b('input-title')">Mobile Name hint</span>
              <a-input
                :class="b('input')"
                type="text"
                placeholder="Enter mobile name hint"
                v-model:value="titleMobile"
              />
            </div>
            <div :class="b('input-wrapper')">
              <span :class="b('input-title')">Description</span>
              <a-input
                :class="b('input')"
                type="text"
                placeholder="Enter description hint"
                v-model:value="descriptionMobile"
              />
            </div>
            <div :class="b('input-wrapper')"
              v-if="!withoutCategory"
            >
              <span :class="b('input-title')">Category</span>
              <a-select
                :class="b('select')"
                placeholder="Select category"
                style="width: 350px"
                :allowClear="true"
                :value="category"
                :options="categories.map((item) => ({ label: item.title, value: item }))"
                @select="handleChangeCategory"
                :onClear="() => category = null"
              />
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane
          key="content"
          tab="Content"
        >
          <div :class="b('description-wrapper')">
            <div
              :class="b('description')"
              v-html="description"
            />
            <div :class="b('editor-wrapper')">
              <tiptap-editor
                :height="600"
                :width="500"
                :value="description"
                v-model:value="description"
              />
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
      <div :class="b('button')">
        <a-button
          type="primary"
          html-type="button"
          @click="onSave"
          size="large"
        >
          {{isNew ? "Add new hint" : 'Edit hint'}}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<style lang="scss">
  @import '@/styles/variables';
  @import "@/styles/media";
  @import "@/styles/fonts";

  .hint-help-center-modal {
    width: 900px;
    min-height: 800px;
    height: 60vh;
    display: flex;
    flex-direction: column;
    gap: 20px;
    overflow: auto;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(20);
    }

    &__title {
      padding: 0;
      margin: 0;
    }

    &__content-wrapper {
      display: flex;
      flex-direction: column;
      gap: 30px;

      @include mediaMinMax(1025, $normal) {
        gap: vw-full(30);
      }
    }

    &__description-wrapper {
      display: flex;
      gap: 20px;
      width: 100%;

      @include mediaMinMax(1025, $normal) {
        gap: vw-full(20);
      }
    }

    &__description {
      width: 100%;
      overflow: scroll;
      height: 600px;
    }

    &__editor-wrapper {
      width: min-content;
    }

    &__uploader {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;

      @include mediaMinMax(1025, $normal) {
        gap: vw-full(20);
      }
    }

    &__video-form {
      width: 100%;
    }

    &__input-wrapper {
      display: flex;
      flex-direction: column;
      gap: 5px;
      max-width: 350px;

      @include mediaMinMax(1025, $normal) {
        gap: 5px;
        max-width: vw-full(350);
      }
    }

    &__input-title {
      font-size: 18px;
      font-weight: 500;

      @include mediaMinMax(1025, $normal) {
        font-size: vw-full(18);
      }
    }

    &__input {
      height: 45px;
      font-size: 16px;

      @include mediaMinMax(1025, $normal) {
        height: vw-full(45);
        font-size: vw-full(16);
      }
    }

    &__select {
      .ant-select-selector,
      .ant-select-selector > span,
      .ant-select-selector > input {
        height: 45px !important;
        line-height: 45px !important;
        font-size: 16px;

        @include mediaMinMax(1025, $normal) {
          height: vw-full(45);
          font-size: vw-full(16);
        }
      }
    }

    &__button {
      margin-left: auto;
      width: fit-content;
      font-size: 18px;

      @include mediaMinMax(1025, $normal) {
        font-size: vw-full(18);
      }
    }
  }
</style>
